import type { GridOverlayProps } from "@mui/x-data-grid/components/containers/GridOverlay";

import { useNonConflictingTheme } from "src/lib/emotion/use-non-conflicting-theme.ts";
import { css, ThemeProvider } from "@emotion/react";

type DataGridNoRowsOverlayProps = GridOverlayProps;

const container = css({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  minHeight: "120px",
  margin: "10px",
});

const inner = css({
  maxWidth: "305px",
  gap: "30px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

export const DataGridOverlay = (props: DataGridNoRowsOverlayProps) => {
  const { children } = props;

  const theme = useNonConflictingTheme();

  return (
    <ThemeProvider theme={theme}>
      <div css={container}>
        <div css={inner}>{children}</div>
      </div>
    </ThemeProvider>
  );
};
